module.exports = __webpack_public_path__ + "img/resp_text_top1.ba723575.png";